import React, { useState } from 'react'
import CustomDateFilter from '../BuisnessDashboard/common/CustomDateFilter'
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Cell, Pie, PieChart, } from 'recharts';

const barData = [
    { name: "Reverse Lead", uv: 12, color: "#FF4242CF" },
    { name: "Shared with Partner", uv: 18, color: "#8A38F5" },
    { name: "Converted by Partner", uv: 10, color: "#3EB0C2" },
    { name: "Pushed to NBFC", uv: 15, color: "#F0B96C" },
    { name: "Loan Disbursed", uv: 8, color: "#4FA564" },
];
const pieData = [
    { name: "Low Credit Score", uv: 12, color: "#3B82F6" },
    { name: "Insufficient Income", uv: 18, color: "#8B5CF6" },
    { name: "High DTI Ratio", uv: 10, color: "#06B6D4" },
    { name: "Incomplete Documents", uv: 15, color: "#F59E0B" },
    { name: "Other Reason", uv: 8, color: "#10B981" },
];

export default function LeadReversalSystem() {
    const [tableData, setTableData] = useState([])
    const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: "", to: "" })
    const [payload, setPayload] = useState({ search: "", partner: "", leadStatus: "", campaignName: "" })

    const handlechange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleDateFilterPopup = (type, val) => {
        setDateFilterPopup((prev) => ({ ...prev, [type]: val }))
    }

    const handleApplyDteFilter = () => {
        handleDateFilterPopup("show", false)
    }
    return (
        <>
            <div className='OverView-Main-Section'>
                <div className='HeadingFilter-Section'>
                    <div>
                        <h4>Lead Reversal System</h4>
                    </div>

                </div>

                <div className='HeadingFilter-main-filters' style={{ marginTop: window.innerWidth > 1800 ? "57px" : "" }}>
                    <div className="row">
                        <div className="col-xl-9 col-lg-10 col-xs-12" style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                            <div className='customInputSearch-bar' style={{ width: window.innerWidth > 1200 ? '35%' : "auto" }}>
                                <i className='fa fa-search'></i>
                                <input placeholder='Search' className='customInput' value={payload?.search} onChange={(e) => handlechange(e, "search")} />
                            </div>
                            <div className='custom-popup' style={{ width: '25%' }}>
                                <div className='customSelectBox ' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px', cursor: 'pointer' }} onClick={() => handleDateFilterPopup("show", !dateFilterPopup?.show)}>
                                    <div style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
                                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 0.75V2.25M3 0.75V2.25" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M1.125 3.75H7.875" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                        Select Date Range
                                    </div>
                                    <div style={{ marginTop: '-5px' }}>
                                        <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375" stroke="#686C70" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                {
                                    dateFilterPopup?.show ?
                                        <CustomDateFilter
                                            payload={dateFilterPopup}
                                            handlechange={handleDateFilterPopup}
                                            handleApply={handleApplyDteFilter}
                                        />
                                        : ""}
                            </div>
                            <select className='customSelectBox' value={payload?.partner} onChange={(e) => handlechange(e, "partner")}>
                                <option value="">Select Partner</option>
                            </select>
                            <select className='customSelectBox' value={payload?.leadStatus} onChange={(e) => handlechange(e, "leadStatus")}>
                                <option value="">Select Status</option>
                            </select>
                            <select className='customSelectBox' value={payload?.campaignName} onChange={(e) => handlechange(e, "campaignName")}>
                                <option value="applyDate">Apply Date</option>
                            </select>
                        </div>
                        <div className="col-xl-3 col-lg-2 col-xs-12" style={{ marginTop: '5px' }}>
                            <div style={{ display: 'flex', gap: '8px', justifyContent: window.innerWidth > 1200 ? 'end' : "start" }}>
                                <div className='custom-btn'>
                                    <i class="fa fa-filter" aria-hidden="true"></i>
                                </div>
                                <div className='custom-btn'>
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </div>
                                <div className='custom-btn'>
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="leadReversalSystem">
                    <div className="row">
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="customCards">
                                <div>
                                    <h5>Total Reversed Leads</h5>
                                    <h4 style={{ margin: '10px 0' }}>3,542</h4>
                                    <h6><span className='colore-green'>+12.5%</span>vs Previous Period</h6>
                                </div>
                                <div>
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="6" fill="#3EC9FB" fill-opacity="0.13" />
                                        <path d="M26.5 11.5H15.5C11.7867 11.5 9 14.185 9 18" stroke="#4FA7C7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.5 24.5H20.5C24.2133 24.5 27 21.815 27 18" stroke="#4FA7C7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M24.5 9C24.5 9 27 10.8412 27 11.5C27 12.1588 24.5 14 24.5 14" stroke="#4FA7C7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M11.5 22C11.5 22 9.00001 23.8412 9 24.5C8.99999 25.1588 11.5 27 11.5 27" stroke="#4FA7C7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="customCards">
                                <div>
                                    <h5>Leads Shared with Partners</h5>
                                    <h4 style={{ margin: '10px 0' }}>2,876</h4>
                                    <h6><span className='colore-green'>+12.5%</span>vs Previous Periovs Previous Period</h6>
                                </div>
                                <div>
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="6" fill="#8A38F5" fill-opacity="0.16" />
                                        <path d="M28 12.75H25.2111C24.61 12.75 24.3094 12.75 24.026 12.6642C23.7426 12.5784 23.4925 12.4116 22.9923 12.0782C22.2421 11.578 21.3862 11.0074 20.961 10.8787C20.5359 10.75 20.085 10.75 19.1833 10.75C17.9571 10.75 17.1667 10.75 16.6154 10.9784C16.0641 11.2067 15.6306 11.6403 14.7635 12.5074L14.0004 13.2704C13.805 13.4659 13.7073 13.5636 13.6469 13.66C13.4233 14.0176 13.4481 14.4771 13.7089 14.8085C13.7792 14.8979 13.8869 14.9846 14.1022 15.1578C14.898 15.7982 16.0452 15.7343 16.7658 15.0094L18 13.7679H19L25 19.8036C25.5523 20.3592 25.5523 21.2599 25 21.8155C24.4477 22.3711 23.5523 22.3711 23 21.8155L22.5 21.3125M22.5 21.3125L19.5 18.2947M22.5 21.3125C23.0523 21.8681 23.0523 22.7689 22.5 23.3244C21.9477 23.88 21.0523 23.88 20.5 23.3244L19.5 22.3185M19.5 22.3185C20.0523 22.874 20.0523 23.7748 19.5 24.3304C18.9477 24.8859 18.0523 24.8859 17.5 24.3304L16 22.8214M19.5 22.3185L17.5 20.3185M16 22.8214L15.5 22.3185M16 22.8214C16.5523 23.377 16.5523 24.2778 16 24.8334C15.4477 25.3889 14.5523 25.3889 14 24.8334L11.1764 21.9509C10.5962 21.3586 10.306 21.0625 9.93435 20.9062C9.56266 20.75 9.14808 20.75 8.31894 20.75H8" stroke="#611FB1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M28 20.75H25.5" stroke="#611FB1" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M14.5 12.75H8" stroke="#611FB1" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>


                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="customCards">
                                <div>
                                    <h5>Total Revenue Generated</h5>
                                    <h4 style={{ margin: '10px 0' }}>₹42.50L</h4>
                                    <h6><span className='colore-green'>+12.5%</span>vs Previous Period</h6>
                                </div>
                                <div>
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="6" fill="#E84E4E" fill-opacity="0.17" />
                                        <path d="M20 9H11C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13H24C24 12.07 24 11.605 23.8978 11.2235C23.6204 10.1883 22.8117 9.37962 21.7765 9.10222C21.395 9 20.93 9 20 9Z" stroke="#EB6062" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9 11V21C9 23.8284 9 25.2426 9.87868 26.1213C10.7574 27 12.1716 27 15 27H21C23.8284 27 25.2426 27 26.1213 26.1213C27 25.2426 27 23.8284 27 21V19C27 16.1716 27 14.7574 26.1213 13.8787C25.2426 13 23.8284 13 21 13H13" stroke="#EB6062" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M27 18H25C24.535 18 24.3025 18 24.1118 18.0511C23.5941 18.1898 23.1898 18.5941 23.0511 19.1118C23 19.3025 23 19.535 23 20C23 20.465 23 20.6975 23.0511 20.8882C23.1898 21.4059 23.5941 21.8102 24.1118 21.9489C24.3025 22 24.535 22 25 22H27" stroke="#EB6062" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="customCards">
                                <div>
                                    <h5>Partner Conversion Rate</h5>
                                    <h4 style={{ margin: '10px 0' }}>68.5%</h4>
                                    <h6><span className='colore-green'>+12.5%</span>vs Previous Period</h6>
                                </div>
                                <div>
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="6" fill="#F49F28" fill-opacity="0.14" />
                                        <path d="M26.5 16.5V25.5C26.5 25.9659 26.5 26.1989 26.4239 26.3827C26.3224 26.6277 26.1277 26.8224 25.8827 26.9239C25.6989 27 25.4659 27 25 27C24.5341 27 24.3011 27 24.1173 26.9239C23.8723 26.8224 23.6776 26.6277 23.5761 26.3827C23.5 26.1989 23.5 25.9659 23.5 25.5V16.5C23.5 16.0341 23.5 15.8011 23.5761 15.6173C23.6776 15.3723 23.8723 15.1776 24.1173 15.0761C24.3011 15 24.5341 15 25 15C25.4659 15 25.6989 15 25.8827 15.0761C26.1277 15.1776 26.3224 15.3723 26.4239 15.6173C26.5 15.8011 26.5 16.0341 26.5 16.5Z" stroke="#F49F28" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M22.5 9H25.5V12" stroke="#F49F28" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M25 9.5C25 9.5 21 14.5 10.5 18" stroke="#F49F28" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M19.5 20V25.5C19.5 25.9659 19.5 26.1989 19.4239 26.3827C19.3224 26.6277 19.1277 26.8224 18.8827 26.9239C18.6989 27 18.4659 27 18 27C17.5341 27 17.3011 27 17.1173 26.9239C16.8723 26.8224 16.6776 26.6277 16.5761 26.3827C16.5 26.1989 16.5 25.9659 16.5 25.5V20C16.5 19.5341 16.5 19.3011 16.5761 19.1173C16.6776 18.8723 16.8723 18.6776 17.1173 18.5761C17.3011 18.5 17.5341 18.5 18 18.5C18.4659 18.5 18.6989 18.5 18.8827 18.5761C19.1277 18.6776 19.3224 18.8723 19.4239 19.1173C19.5 19.3011 19.5 19.5341 19.5 20Z" stroke="#F49F28" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M12.5 22.5V25.5C12.5 25.9659 12.5 26.1989 12.4239 26.3827C12.3224 26.6277 12.1277 26.8224 11.8827 26.9239C11.6989 27 11.4659 27 11 27C10.5341 27 10.3011 27 10.1173 26.9239C9.87229 26.8224 9.67761 26.6277 9.57612 26.3827C9.5 26.1989 9.5 25.9659 9.5 25.5V22.5C9.5 22.0341 9.5 21.8011 9.57612 21.6173C9.67761 21.3723 9.87229 21.1776 10.1173 21.0761C10.3011 21 10.5341 21 11 21C11.4659 21 11.6989 21 11.8827 21.0761C12.1277 21.1776 12.3224 21.3723 12.4239 21.6173C12.5 21.8011 12.5 22.0341 12.5 22.5Z" stroke="#F49F28" stroke-width="1.5" stroke-linejoin="round" />
                                    </svg>


                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="customCards">
                                <div>
                                    <h5>NBFC Conversion Rate</h5>
                                    <h4 style={{ margin: '10px 0' }}>52.3%</h4>
                                    <h6><span className='colore-red'>+12.5%</span>vs Previous Period</h6>
                                </div>
                                <div>
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="6" fill="#4FA564" fill-opacity="0.17" />
                                        <path d="M8 14.5691C8 13.3729 8.48238 12.6398 9.48063 12.0843L13.5899 9.79744C15.7431 8.59915 16.8197 8 18 8C19.1803 8 20.2569 8.59915 22.4101 9.79744L26.5194 12.0843C27.5176 12.6398 28 13.3729 28 14.5691C28 14.8934 28 15.0556 27.9646 15.1889C27.7785 15.8895 27.1437 16 26.5307 16H9.46928C8.85627 16 8.22152 15.8894 8.03542 15.1889C8 15.0556 8 14.8934 8 14.5691Z" stroke="#4FA564" stroke-width="1.5" />
                                        <path d="M17.9961 13H18.0051" stroke="#4FA564" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10 16V24.5M14 16V24.5" stroke="#4FA564" stroke-width="1.5" />
                                        <path d="M22 16V24.5M26 16V24.5" stroke="#4FA564" stroke-width="1.5" />
                                        <path d="M25 24.5H11C9.34315 24.5 8 25.8431 8 27.5C8 27.7761 8.22386 28 8.5 28H27.5C27.7761 28 28 27.7761 28 27.5C28 25.8431 26.6569 24.5 25 24.5Z" stroke="#4FA564" stroke-width="1.5" />
                                    </svg>



                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="customCards">
                                <div>
                                    <h5>Avg Revenue per Lead</h5>
                                    <h4 style={{ margin: '10px 0' }}>₹1,200</h4>
                                    <h6><span className='colore-green'>+12.5%</span>vs Previous Period</h6>
                                </div>
                                <div>
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="6" fill="#3053D3" fill-opacity="0.14" />
                                        <path d="M26.9427 22.8354C26.2864 18.8866 24.2432 15.9461 22.467 14.219C21.9501 13.7164 21.6917 13.4651 21.1208 13.2326C20.5499 13 20.0592 13 19.0778 13H16.9222C15.9408 13 15.4501 13 14.8792 13.2326C14.3083 13.4651 14.0499 13.7164 13.533 14.219C11.7568 15.9461 9.71361 18.8866 9.05727 22.8354C8.56893 25.7734 11.2793 28 14.3083 28H21.6917C24.7207 28 27.4311 25.7734 26.9427 22.8354Z" stroke="#3053D3" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M16.125 23.5V17.5M18 17.5V16M18 25V23.5M16.125 20.5H19.875M19.875 20.5C20.4963 20.5 21 21.0037 21 21.625V22.375C21 22.9963 20.4963 23.5 19.875 23.5H15M19.875 20.5C20.4963 20.5 21 19.9963 21 19.375V18.625C21 18.0037 20.4963 17.5 19.875 17.5H15" stroke="#3053D3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M13.2566 10.4429C13.0503 10.1426 12.7513 9.73499 13.369 9.64205C14.0039 9.54651 14.6632 9.98114 15.3085 9.97221C15.8924 9.96413 16.1898 9.70519 16.5089 9.33548C16.8449 8.94617 17.3652 8 18 8C18.6348 8 19.1551 8.94617 19.4911 9.33548C19.8102 9.70519 20.1076 9.96413 20.6914 9.97221C21.3368 9.98114 21.9961 9.54651 22.631 9.64205C23.2487 9.73499 22.9497 10.1426 22.7434 10.4429L21.8105 11.8006C21.4115 12.3815 21.212 12.6719 20.7944 12.8359C20.3769 13 19.8373 13 18.7582 13H17.2418C16.1627 13 15.6231 13 15.2056 12.8359C14.788 12.6719 14.5885 12.3815 14.1895 11.8006L13.2566 10.4429Z" stroke="#3053D3" stroke-width="1.5" />
                                    </svg>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-7 col-xs-12">
                            <div className="customGraphboard" style={{ marginTop: '20px' }}>
                                <h5 className='head'>Lead Funnel Graph</h5>
                                <div className="row" >
                                    <div className="col-sm-8 col-xs-12" style={{ marginTop: '10px' }}>
                                        <div style={{ height: '300px' }}>
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart data={barData}
                                                    barSize={40}
                                                    layout="vertical"
                                                >

                                                    <CartesianGrid vertical={false} horizontal={false} />
                                                    <XAxis type="number" tickLine={false} />
                                                    <YAxis dataKey="name"
                                                        type="category"
                                                        width={120}
                                                        tickLine={false}
                                                        tick={{
                                                            fontSize: 12,
                                                            fontWeight: 400,
                                                            fill: "#374151", // optional text color
                                                        }}
                                                    />
                                                    <Bar dataKey="uv">
                                                        {barData.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill={entry.color} radius={[10, 10, 10, 10]} />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <div className='legendCards'>
                                            <div className="cardbox">
                                                <h5>Reversed → Shared</h5>
                                                <h4 style={{ color: '#4877E4' }}>81.2%</h4>
                                            </div>
                                            <div className="cardbox">
                                                <h5>Shared → Converted</h5>
                                                <h4 style={{ color: '#8A38F5' }}>68.5%</h4>
                                            </div>
                                            <div className="cardbox">
                                                <h5>Converted → NBFC</h5>
                                                <h4 style={{ color: '#EB6062' }}>84.0%</h4>
                                            </div>
                                            <div className="cardbox">
                                                <h5>NBFC → Disbursed</h5>
                                                <h4 style={{ color: '#4FA564' }}>74.6%</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-5 col-xs-12">
                            <div className="customGraphboard" style={{ marginTop: '20px' }}>
                                <h5 className='head'>Rejection Reason Analysis</h5>
                                <div className="row" >
                                    <div className="col-sm-8 col-xs-12" style={{ marginTop: '10px' }}>
                                        <div style={{ height: '300px' }}>
                                            <ResponsiveContainer width="100%" height={300}>
                                                <PieChart
                                                    outerRadius="80%"
                                                    responsive
                                                >
                                                    <Pie
                                                        data={pieData}
                                                        dataKey="uv"
                                                        cx="50%"
                                                        cy="50%"
                                                        outerRadius="80%"
                                                        fill="#82ca9d"


                                                    >
                                                        {pieData.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                                        ))}
                                                    </Pie>
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <div className='legendCards'>
                                            {
                                                pieData && pieData?.map((val, id) => {
                                                    return (
                                                        <div className="CircleBox" style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                            <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: val?.color }}></div>
                                                            <h4 style={{ color: val?.color, fontSize: '11px' }}>{val?.name}</h4>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-7 col-xs-12">
                            <div className="customDash-table" style={{ marginTop: '20px' }}>
                                <div>
                                    <h5>Campaign Performance</h5>
                                </div>
                                <div className='main-customized-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th>Campaign Name</th>
                                                <th>Type </th>
                                                <th>Leads Assigned</th>
                                                <th>Partner Conv %</th>
                                                <th>NBFC Conv %</th>
                                                <th>Total Revenue</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                tableData?.length > 0 ? tableData?.map((val, id) => {
                                                    return (
                                                        <tr key={id}>

                                                            <td></td>
                                                        </tr>
                                                    )
                                                })
                                                    : ""}

                                            <tr>

                                                <td>
                                                    Personal Loan Drive
                                                </td>
                                                <td>
                                                    <div style={{ borderRadius: '4px', background: '#0D99FF30', padding: '5px 10px', color: '#0D99FF' }}>SMS</div>
                                                </td>
                                                <td>
                                                    50
                                                </td>
                                                <td style={{ color: '#8A38F5' }}>
                                                    72.5%
                                                </td>
                                                <td style={{ color: '#E84E4E' }}>
                                                    58.3%
                                                </td>
                                                <td style={{ color: '#327E45' }}>
                                                    ₹16.50L
                                                </td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-5 col-xs-12">
                            <div className="customTabscards" style={{ marginTop: '20px' }}>
                                <div>
                                    <h5>Revenue by Rejection Reason</h5>
                                </div>

                                <div className='cropTabs' style={{ padding: '18px 0 ', borderBottom: '1px solid #0000000F' }}>
                                    <div className='leftTab'>
                                        <div className='circleTab' style={{ background: "#3B82F6" }}></div>
                                        <div>
                                            <h5>Low Credit Score</h5>
                                            <h6>1245 leads (35.1%)</h6>
                                        </div>
                                    </div>
                                    <div className='rightTab'>
                                        <h4>₹15.20L</h4>
                                        <h6>₹1,220.884 / lead</h6>
                                    </div>
                                </div>
                                <div className='cropTabs' style={{ padding: '18px 0 ', borderBottom: '1px solid #0000000F' }}>
                                    <div className='leftTab'>
                                        <div className='circleTab' style={{ background: "#8B5CF6" }}></div>
                                        <div>
                                            <h5>Insufficient Income</h5>
                                            <h6>892 leads (25.2%)</h6>
                                        </div>
                                    </div>
                                    <div className='rightTab'>
                                        <h4>₹10.80L</h4>
                                        <h6>₹1,210.762 / lead</h6>
                                    </div>
                                </div>
                                <div className='cropTabs' style={{ padding: '18px 0 ', borderBottom: '1px solid #0000000F' }}>
                                    <div className='leftTab'>
                                        <div className='circleTab' style={{ background: "#06B6D4" }}></div>
                                        <div>
                                            <h5>High DTI Ratio</h5>
                                            <h6>654 leads (18.5%)</h6>
                                        </div>
                                    </div>
                                    <div className='rightTab'>
                                        <h4>₹7.80L</h4>
                                        <h6>₹1,192.661 / lead</h6>
                                    </div>
                                </div>
                                <div className='cropTabs' style={{ padding: '18px 0 ', borderBottom: '1px solid #0000000F' }}>
                                    <div className='leftTab'>
                                        <div className='circleTab' style={{ background: "#F59E0B" }}></div>
                                        <div>
                                            <h5>Incomplete Documents</h5>
                                            <h6>435 leads (12.3%)</h6>
                                        </div>
                                    </div>
                                    <div className='rightTab'>
                                        <h4>₹5.20L</h4>
                                        <h6>₹1,195.402 / lead</h6>
                                    </div>
                                </div>
                                <div className='cropTabs' style={{ padding: '18px 0 ' }}>
                                    <div className='leftTab'>
                                        <div className='circleTab' style={{ background: "#10B981" }}></div>
                                        <div>
                                            <h5>Other Reasons</h5>
                                            <h6>316 leads (8.9%)</h6>
                                        </div>
                                    </div>
                                    <div className='rightTab'>
                                        <h4>₹3.50L</h4>
                                        <h6>₹1,107.595 / lead</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        <h5 className='head'>Current Lead Status</h5>
                        <div className="row">
                            <div className="col-sm-3 col-xs-12">
                                <div style={{ margin: '10px 5px 5px 5px', borderRadius: '10px', border: "1px solid #E84E4E", background: "#E979793B", padding: '20px 15px', display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                                    <div>
                                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="25" height="25" rx="4" fill="#EB6062" fill-opacity="0.1" />
                                            <path d="M12.5007 20.4168C16.8729 20.4168 20.4173 16.8724 20.4173 12.5002C20.4173 8.12791 16.8729 4.5835 12.5007 4.5835C8.1284 4.5835 4.58398 8.12791 4.58398 12.5002C4.58398 16.8724 8.1284 20.4168 12.5007 20.4168Z" stroke="#E84E4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12.5 9.3335V12.896" stroke="#E84E4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12.5 15.6572V15.6656" stroke="#E84E4E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </div>
                                    <div>
                                        <h5 style={{ fontSize: '14px', fontWeight: '500', color: "#E84E4E", margin: '0', padding: '0' }}>Reserved But Not Shared</h5>
                                        <h6 style={{ fontSize: '26px', fontWeight: '500', color: '#E84E4E', margin: '5px 0 0 0', padding: '0' }}>666</h6>
                                    </div>

                                </div>
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <div style={{ margin: '10px 5px 5px 5px', borderRadius: '10px', border: "1px solid #F4D928", background: "#F4D92817", padding: '20px 15px', display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                                    <div>
                                       <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="25" height="25" rx="4" fill="#F4D928" fill-opacity="0.18"/>
<path d="M20.4173 12.5002C20.4173 8.12791 16.8729 4.5835 12.5007 4.5835C8.12839 4.5835 4.58398 8.12791 4.58398 12.5002C4.58398 16.0066 6.86368 18.9807 10.0218 20.021M10.1257 14.0835L12.5007 12.5002V8.27822" stroke="#F4D928" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.291 15.6665H14.8743C15.3116 15.6665 15.666 16.0209 15.666 16.4582V17.2498C15.666 17.6871 15.3116 18.0415 14.8743 18.0415H14.0827C13.6454 18.0415 13.291 18.3959 13.291 18.8332V19.6248C13.291 20.0621 13.6454 20.4165 14.0827 20.4165H15.666" stroke="#F4D928" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.416 15.6665V18.0415M20.416 18.0415H18.8327C18.3954 18.0415 18.041 17.6871 18.041 17.2498V15.6665M20.416 18.0415V20.4165" stroke="#F4D928" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


                                    </div>
                                    <div>
                                        <h5 style={{ fontSize: '14px', fontWeight: '500', color: "#F4D928", margin: '0', padding: '0' }}>Shared but No Response</h5>
                                        <h6 style={{ fontSize: '26px', fontWeight: '500', color: '#F4D928', margin: '5px 0 0 0', padding: '0' }}>906</h6>
                                    </div>

                                </div>
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <div style={{ margin: '10px 5px 5px 5px', borderRadius: '10px', border: "1px solid #4FA564", background: "#35A04F2B", padding: '20px 15px', display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                                    <div>
                                       <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="25" height="25" rx="4" fill="#327E45" fill-opacity="0.1"/>
<path d="M20.4173 12.5002C20.4173 8.12791 16.8729 4.5835 12.5007 4.5835C8.12839 4.5835 4.58398 8.12791 4.58398 12.5002C4.58398 16.8724 8.12839 20.4168 12.5007 20.4168C16.8729 20.4168 20.4173 16.8724 20.4173 12.5002Z" stroke="#327E45" stroke-width="1.5"/>
<path d="M9.33398 13.0939C9.33398 13.0939 10.6007 13.8163 11.234 14.8752C11.234 14.8752 13.134 10.7189 15.6673 9.3335" stroke="#327E45" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


                                    </div>
                                    <div>
                                        <h5 style={{ fontSize: '14px', fontWeight: '500', color: "#327E45", margin: '0', padding: '0' }}>Converted by Partner</h5>
                                        <h6 style={{ fontSize: '26px', fontWeight: '500', color: '#327E45', margin: '5px 0 0 0', padding: '0' }}>1,970</h6>
                                    </div>

                                </div>
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <div style={{ margin: '10px 5px 5px 5px', borderRadius: '10px', border: "1px solid #D9D9D9", background: "#686C700A", padding: '20px 15px', display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                                    <div>
                                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="25" height="25" rx="4" fill="#5A4B5F" fill-opacity="0.1"/>
<path d="M20.4173 12.5002C20.4173 8.12791 16.8729 4.5835 12.5007 4.5835C8.12839 4.5835 4.58398 8.12791 4.58398 12.5002C4.58398 16.8724 8.12839 20.4168 12.5007 20.4168C16.8729 20.4168 20.4173 16.8724 20.4173 12.5002Z" stroke="#5A4B5F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.8745 14.875L10.125 10.125M10.1255 14.875L14.875 10.125" stroke="#5A4B5F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


                                    </div>
                                    <div>
                                        <h5 style={{ fontSize: '14px', fontWeight: '500', color: "#5A4B5F", margin: '0', padding: '0' }}>Reserved But Not Shared</h5>
                                        <h6 style={{ fontSize: '26px', fontWeight: '500', color: '#5A4B5F', margin: '5px 0 0 0', padding: '0' }}>666</h6>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                             <div className="customDash-table" style={{ marginTop: '20px' }}>
                                <div>
                                    <h5>Lead data Table</h5>
                                </div>
                                <div className='main-customized-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th>Lead ID</th>
                                                <th>Original Rejection Reason </th>
                                                <th>Assigned Partner</th>
                                                <th>Status</th>
                                                <th>Campaign Name</th>
                                                <th>Campaign Type</th>
                                                <th>Shared Loan Amount</th>
                                                <th>Converted Loan Amount</th>
                                                <th>Revenue</th>
                                                <th>Date Reversed</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                tableData?.length > 0 ? tableData?.map((val, id) => {
                                                    return (
                                                        <tr key={id}>

                                                            <td></td>
                                                        </tr>
                                                    )
                                                })
                                                    : ""}

                                            <tr>

                                                <td>
                                                    L-100231
                                                </td>
                                                <td>
                                                    Low Credit Score
                                                </td>
                                                <td>
                                                    Partner A
                                                </td>
                                                <td>
                                                    <div style={{ borderRadius: '4px', background: '#8C9BFF5C', padding: '5px 10px', color: '#0E2B94' }}>Reserved</div>
                                                </td>
                                                <td>
                                                    Jan_SMS_Blast
                                                </td>
                                                <td>
                                                    SMS
                                                </td>
                                                <td>
                                                    1,50,000
                                                </td>
                                                <td>
                                                   1,20,000
                                                </td>
                                                <td style={{ color: '#327E45' }}>
                                                   450
                                                </td>
                                                <td>
                                                  10 Jan 2026
                                                </td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
